import React from "react";
import classes from "./SentimentChangePercent.module.css";

const LargestSentimentMovementBar = ({ concept, last = false }) => {
    return (
        <div className={classes.sentimentBarBlock}>
            <div style={{ display: "flex", columnGap: "5px", minWidth: "90px", marginRight: "10px" }}>
                <span style={{ color: "rgb(245, 150, 148)" }}>
                     {(concept.negative * 100).toFixed(0)}%
                </span>
                <span style={{ color: "#BDBCC8" }}>
                     {(concept.neutral * 100).toFixed(0)}%
                </span>

                <span style={{ color: "rgb(120, 208, 239)" }}>
                    {(concept.positive * 100).toFixed(0)}%
                </span>
            </div>
            <div className={classes.sentimentBarContainer} style={{
                height: `${last ? "10px" : " 16px"}`,
            }}>
                <div
                    className={classes.sentimentBar}
                    style={{
                        opacity: `${last ? "0.6" : "1"}`,
                        height: `${last ? "10px" : "16px"}`,
                        width: `${(concept.negative * 100).toFixed(0)}%`,
                        borderRadius: "2px",
                        background: "rgb(245, 150, 148)",
                    }}
                    title={`${(concept.negative * 100).toFixed(0)} %`}
                />
                <div
                    className={classes.sentimentBar}
                    style={{
                        opacity: `${last ? "0.6" : "1"}`,
                        height: `${last ? "10px" : " 16px"}`,
                        width: `${(concept.neutral * 100).toFixed(0)}%`,
                        borderRadius: "2px",
                        background: "#BDBCC8",
                    }}
                    title={`${(concept.neutral * 100).toFixed(0)} %`}
                />

                <div
                    className={classes.sentimentBar}
                    style={{
                        opacity: `${last ? "0.6" : "1"}`,
                        height: `${last ? "10px" : " 16px"}`,
                        width: `${(concept.positive * 100).toFixed(0)}%`,
                        borderRadius: "2px",
                        background: "rgb(120, 208, 239)",
                    }}
                    title={`${(concept.positive * 100).toFixed(0)} %`}
                />
            </div>
        </div>
    );
};

export default LargestSentimentMovementBar;
